import { alpha } from "@material-ui/core";

const menuStyle = (label, theme) => {
  return {
    py: 1.5,
    mx: 1,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    color: theme?.palette?.text?.primary || "#111927",
    fontWeight: 500,
    "&.MuiMenuItem-root .MuiListItemIcon-root .MuiSvgIcon-root": {
      color: theme?.palette?.text?.primary || "#111927",
    },
    "&:hover": {
      color: label === "delete" ? "red" : theme?.palette?.primary?.main || "#111927",
      backgroundColor:
        label === "delete" ? alpha("#f44336", 0.1) : alpha("#2196f3", 0.1),
      "&.MuiMenuItem-root .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: label === "delete" ? "red" : theme?.palette?.primary?.main || "#111927",
      },
    },
    borderRadius: 1,
  };
}; 
export default menuStyle;